export enum BranchListPanelOptions {
  AllNodes = 'allNodes',
  DecisionPoints = 'decisionPoints',
  ChapterPass = 'chapterPass',
  Remember = 'remember',
  Random = 'random',
}
